import Vue from 'vue';
import VueRouter from 'vue-router';
import loginRoute from './login';
import mainRoute from './main/main-router';

Vue.use(VueRouter);

const routes = [
  loginRoute,
  mainRoute,
  {
    path: '*',
    redirect: { name: 'login' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
